import React from 'react';
import PropTypes from 'prop-types';
import reactifyWC from 'reactify-wc';
import { useTranslation } from 'react-i18next';
import Widget from 'components/shared/Widget';

const NBXModalContainer = reactifyWC('nbx-modal-container');

const AUTO_CLOSE_DELAY = 2000;

export const CardAuthorizationModal = ({ closeModal, subject, sessionId, cardId }) => {
  const { t } = useTranslation();

  return (
    <NBXModalContainer open onRequestClose={closeModal} onRequestSubmit={closeModal}>
      <nbx-modal-overlay slot="overlay" onClick={closeModal} />
      <nbx-modal-alert slot="modal">
        <Widget
          widget="card"
          parcelName="CardAuthorizationWidget"
          closeModal={closeModal}
          sessionId={sessionId}
          authorizationRequest={{
            subject,
            sessionId,
            cardId
          }}
          onSubmitAuthorization={() => setTimeout(closeModal, AUTO_CLOSE_DELAY)}
        />
        <nbx-button slot="center-button" onClick={closeModal}>
          {t('common_close')}
        </nbx-button>
      </nbx-modal-alert>
    </NBXModalContainer>
  );
};

CardAuthorizationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  subject: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  cardId: PropTypes.string.isRequired
};
